<template>
  <div class="failureAccess">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" >
      <i class="iconfont icon-chenggong-icon topicon"></i>
    <p class="title">预授信成功</p>
    <!--如果有提现金额才显示，没有不显示-->
    <HavingMoneyShow  v-if="this.$store.state.commonForms.bwAmount !== null"/>
    <div class="orderInfo" >
      <div class="shell">
        <p class="list">
          <span class="fl">客户经理</span><span class="fr ">{{ this.$store.state.commonForms.pinganAccountManager }}</span>
        </p>
        <p class="list">
          <span class="fl">联系方式</span><span class="fr ">{{ this.$store.state.commonForms.pinganAccountManagerMobile }}</span>
        </p>
        <p class="list">
          <span class="fl">截止日期</span
          ><span class="fr ">{{ this.$store.state.commonForms.pinganDealLineTime }}</span>
        </p>
      </div>
    </div>
    <p class="warn">*请在截止日期之前联系银行客户经理进行面签</p>
    <div class="box"></div>
     </van-pull-refresh>
  </div>
</template>

<script>
// @ is an alias to /src
import HavingMoneyShow from './components/HaveMoneyShow.vue';
import { checkStatus } from './mixin';

export default {
  name: 'WaitingEvaluate',
  components: {
    HavingMoneyShow,
  },
  data() {
    return {
      isLoading: false,
      danger: 'danger',
      plain: 'plain',
    };
  },
  mixins: [checkStatus],
  watch: {
    creditAmount: () => {

    },
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.$store.dispatch('commonForms/checkCurrentStatus', { getInfo: false });
        this.isLoading = false;
      }, 500);
    },
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background-color:#fff');
  },
  mounted() {
    this.$store.dispatch('commonForms/checkCurrentStatus', { getInfo: false });
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style');
  },
};
</script>
<style scoped>
.title {
  color: #1c2438;
  font-size: 17px;
  letter-spacing: 0;
  text-align: center;
}
.warn {
  box-sizing: border-box;
  height: 44px;
  margin: 0;
  padding: 0;
  padding-right: 15px;
  padding-left: 15px;
  color: #F55646;
  font-size: 14px;
  line-height: 44px;
  letter-spacing: 0;
  text-align: left;
}
.shell {
  box-sizing: border-box;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
.list {
  height: 44px;
  margin: 0;
  padding: 0;
  color: #495060;
  font-size: 14px;
  line-height: 44px;
  letter-spacing: 0;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.topicon {
  display: block;
  padding-top: 103px;
  color: #F65249;
  font-size: 60px;
}
.box {
  width: 100%;
  height: 200px;
}
</style>
